document.addEventListener('DOMContentLoaded', function () {
  var triggers = document.querySelectorAll('[data-lightbox-trigger]');
  var lightbox = document.querySelector('[data-lightbox]');
  if (!lightbox || triggers.length === 0) return;

  // Move the lightbox to be a direct child of <body>. This sidesteps a
  // common CSS gotcha: `position: fixed` becomes relative to the nearest
  // ancestor with a `transform`/`filter`/`will-change` set (Shopify themes
  // often apply these for scroll animations), NOT the actual viewport, if
  // such an ancestor exists anywhere above the element in the DOM. Moving
  // it to <body> guarantees it's always positioned against the real screen.
  document.body.appendChild(lightbox);

  var images = lightbox.querySelectorAll('[data-lightbox-image]');
  var closeButtons = lightbox.querySelectorAll('[data-lightbox-close]');
  var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  var nextBtn = lightbox.querySelector('[data-lightbox-next]');
  var closeBtnEl = lightbox.querySelector('button.feature-showcase__lightbox-close');
  var currentIndex = 0;
  var lastTrigger = null;

  function showImage(index) {
    var total = images.length;
    if (total === 0) return;
    currentIndex = (index + total) % total;

    images.forEach(function (img) {
      var imgIndex = parseInt(img.getAttribute('data-lightbox-image'), 10);
      img.hidden = imgIndex !== currentIndex;
    });
  }

  function openLightbox(index, triggerEl) {
    lastTrigger = triggerEl || null;
    showImage(index);
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    // Move keyboard focus into the lightbox for accessibility
    if (closeBtnEl) closeBtnEl.focus();
  }

  function closeLightbox() {
    lightbox.hidden = true;
    document.body.style.overflow = '';
    // Return focus to whatever opened it, rather than leaving focus stuck
    // on a now-hidden element
    if (lastTrigger) lastTrigger.focus();
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var index = parseInt(trigger.getAttribute('data-lightbox-index'), 10) || 0;
      openLightbox(index, trigger);
    });
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closeLightbox);
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      showImage(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      showImage(currentIndex + 1);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showImage(currentIndex - 1);
    if (event.key === 'ArrowRight') showImage(currentIndex + 1);
  });
});